module.exports = __webpack_public_path__ + "b2aa6270d62c0961398929424fde8ba3.svg";